import { resolveValuesSet } from './generic-conversion.js';
export const resolveInSet = (dbAtom, dependencies) => {
    const inSet = {};
    // Set default values derived from the type
    inSet.output_type = 'boolean';
    inSet.type = 'in-set-condition';
    // Convert all the db values in the array
    inSet.value_set = resolveValuesSet(dbAtom.cases[0], dependencies);
    return inSet;
};
export const resolveInSetConversion = (dbAtom, baseConversion, dependencies) => {
    const inSetConversion = baseConversion;
    inSetConversion.type = 'in-set-conversion';
    inSetConversion.options = dbAtom.cases.map(_case => {
        return {
            value_set: resolveValuesSet(_case, dependencies),
            return_value: inSetConversion.output_type === 'tuple' ? _case.value : _case.value[0] // getConversionOutputType validates that all cases have values
        };
    });
    return inSetConversion;
};
//# sourceMappingURL=set.js.map